import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";

import Styles from "./PlayerMenuItem.styles";

const PlayerMenuItem = props => {
  const selected = props.isSelected ? Styles.selected : {};
  const colorProp = props.isSelected
    ? { background: props.color }
    : { color: props.color };
  return (
    <div
      role="button"
      tabIndex="-1"
      style={[Styles.item, selected, colorProp]}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};

PlayerMenuItem.defaultProps = {
  isSelected: false
};
PlayerMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool
};

export default Radium(PlayerMenuItem);



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMenu/PlayerMenuItem/PlayerMenuItem.js